import { HeaderIconLinkRow, InfoCardVariants, Link, MarkdownContent, IconLinkVerticalProps } from "@backstage/core-components"
import { featureFlagsApiRef } from "@backstage/core-plugin-api"
import { IconButton, Grid, Card, CardContent, CardHeader, Divider, Chip } from "@material-ui/core"
import React, { useCallback, useEffect, useState } from "react"
import { EaPackDomainEntityV1beta1, EaPackSystemEntityV1beta1 } from "@internal/plugin-ea-pack-common"
import { makeStyles } from '@material-ui/core/styles';
import { AboutField } from "@backstage/plugin-catalog"
import CachedIcon from '@material-ui/icons/Cached';
import EditIcon from '@material-ui/icons/Edit';

import {
    alertApiRef,
    errorApiRef,
    useApi,
} from '@backstage/core-plugin-api';
import {
    catalogApiRef,
    EntityRefLinks,
    getEntityRelations,
    useEntity,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_EDIT_URL, parseEntityRef, RELATION_PART_OF, stringifyEntityRef } from "@backstage/catalog-model"
import { TeamPreviewField } from "./TeamPreviewField"
const useStyles = makeStyles({
    gridItemCard: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 10px)', // for pages without content header
        marginBottom: '10px',
    },
    gridItemCardContent: {
        flex: 1,
    },
    description: {
        wordBreak: 'break-word',
    },
    avatar: {
        borderWidth: 2,
        borderColor: 'black',
        borderStyle: 'solid',
    },
    avatarItem: {
        marginLeft: "-40px",
    }
});

export const ProductInfoCard = (props: { variant: InfoCardVariants }) => {

    const { variant } = props;
    var entity = useEntity().entity as EaPackSystemEntityV1beta1;

    const classes = useStyles();
    const catalogApi = useApi(catalogApiRef);
    const alertApi = useApi(alertApiRef);
    const errorApi = useApi(errorApiRef);
    const featureFlagsApi = useApi(featureFlagsApiRef);

    var [subDomain, setSubDomain] = useState<EaPackDomainEntityV1beta1 | undefined>(undefined);
    var [functionalDomain, setFunctionalDomain] = useState<EaPackDomainEntityV1beta1 | undefined>(undefined);

    useEffect(() => {
        (async () => {
            if (entity.spec.domain) {
                const subDomainEntity = await catalogApi.getEntityByRef({ name: entity.spec.domain, kind: "Domain", namespace: "default" });
                if (subDomainEntity) {
                    setSubDomain(subDomainEntity as EaPackDomainEntityV1beta1);
                }
            }
            if (entity.spec.functionalDomain) {
                const functionalDomainEntity = await catalogApi.getEntityByRef({ name: entity.spec.functionalDomain, kind: "Domain", namespace: "default" });
                if (functionalDomainEntity) {
                    setFunctionalDomain(functionalDomainEntity as EaPackDomainEntityV1beta1);
                }
            }
        })();
    }, [catalogApi]);



    const refreshEntity = useCallback(async () => {
        try {
            await catalogApi.refreshEntity(stringifyEntityRef(entity));
            alertApi.post({
                message: "Product refresh scheduled",
                severity: 'info',
                display: 'transient',
            });
        } catch (e) {
            errorApi.post(e as Error);
        }
    }, [catalogApi, entity, alertApi, errorApi]);

    return (<Card className={classes.gridItemCard}>
        <CardHeader
            title={`${entity.metadata.title ?? entity.metadata.name ?? ""} at a glance`}
            action={
                <>
                    <IconButton aria-label="Refresh" title="Refresh" onClick={refreshEntity} >
                        <CachedIcon />
                    </IconButton>
                    <IconButton component={Link} aria-label="Edit" title="Edit" to={entity.metadata.annotations?.[ANNOTATION_EDIT_URL] ?? '#'} >
                        <EditIcon />
                    </IconButton>
                </>
            }
        />
        <Divider />
        <CardContent className={classes.gridItemCardContent}>
            <Grid container>
                {/* <AboutField
                    label={t('aboutCard.ownerField.label')}
                    value={t('aboutCard.ownerField.value')}
                    gridSizes={{ xs: 12, sm: 6, lg: 4 }}
                >
                    {ownedByRelations.length > 0 && (
                        <EntityRefLinks entityRefs={ownedByRelations} defaultKind="group" />
                    )}
                </AboutField> */}
                <Grid item xs={12} sm={6} lg={4}>
                    <AboutField label={"Organisational Domain"}>
                        {subDomain && subDomain.spec.subdomainOf && (<EntityRefLinks entityRefs={[parseEntityRef(subDomain.spec.subdomainOf, { defaultKind: "domain" })]} defaultKind="domain" />)}
                    </AboutField>
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                    <AboutField label={subDomain?.spec.subDomainType ?? "..."}>
                        {subDomain && (<EntityRefLinks entityRefs={[subDomain]} defaultKind="domain" />)}
                    </AboutField>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                    <AboutField label={"Tags"}>
                        {(entity?.metadata?.tags || []).map(tag => (
                            <Chip key={tag} size="small" label={tag} />
                        ))}
                    </AboutField>
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                    <AboutField label={"Enterprise Layer"}>
                        {functionalDomain && functionalDomain.spec.subdomainOf && (<EntityRefLinks entityRefs={[parseEntityRef(functionalDomain.spec.subdomainOf, { defaultKind: "domain" })]} defaultKind="domain" />)}
                    </AboutField>
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                    <AboutField label={"Functional Domain"}>
                        {functionalDomain && (<EntityRefLinks entityRefs={[functionalDomain]} defaultKind="domain" />)}
                    </AboutField>
                </Grid>
                <Grid item xs={12}>
                    <AboutField label={"The team behind"}>
                        <TeamPreviewField />
                    </AboutField>
                </Grid>
                <Grid item xs={12}>
                    <AboutField label={"Description"}>
                        <MarkdownContent className={classes.description} content={entity?.metadata?.description || "No description provided."} />
                    </AboutField>
                </Grid>
            </Grid>
        </CardContent>
    </Card>);
}